<template>
	<div class="d-flex flex-column justify-content-center h-75 mr-3">
            <table v-for="(match, index) in wildcard.filter(({ playoffStage }) => playoffStage === 4)" :key="index" class="match-table">
              <tbody>
                <tr :class="`${$emit(getPoints(match.home_players)) > $emit(getPoints(match.away_players)) || match.tech_loser === match.away_team._id ? 'font-weight-bold ' : ''}`">
                  <td class="w-300px">
                    <span v-if="matches.length">
                      {{ match.home_team.name ? match.home_team.name : match.home_team }}
                    </span>
                  </td>
                  <td class="w-60px position-relative">
                    <span v-if="matches.length">
                      {{ match.tech_loser ? getTechPoints(match, match.home_team) : $emit(getPoints(match.home_players)) }}
                    </span>
                    <Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openModal(match)" />
                  </td>
                </tr>
                <tr :class="`${$emit(getPoints(match.home_players)) < $emit(getPoints(match.away_players)) || match.tech_loser === match.home_team._id ? 'font-weight-bold ' : ''}`">
                  <td class="w-300px">
                    <span v-if="matches.length">
                      {{ match.away_team.name ? match.away_team.name : match.away_team }}
                    </span>
                  </td>
                  <td class="w-60px">
                    <span v-if="matches.length">
                      {{ match.tech_loser ? getTechPoints(match, match.away_team) : $emit(getPoints(match.away_players)) }}
                    </span>
                </td>
                </tr>
              </tbody>
            </table>
          </div>
</template>

<script>
	export default {
		name: 'PlayoffStageFour',
		props: ['wildcard'],
		data() {
			return {};
		},
		mounted() {
			console.log('this.wildcard', this.wildcard);
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/competitions/utils/PlayoffStageFour.vue